var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m461.48 337.3c-52.305 0-94.246 41.941-94.246 93.754s41.941 94.246 94.246 94.246c51.812 0 93.754-42.438 93.754-94.246 0-51.812-41.945-93.754-93.754-93.754zm0.48828 37.5c14.805 0 28.621 5.9219 39.477 16.285 15.793 16.285 20.727 40.957 11.844 62.176-5.9219 14.805-18.258 25.66-32.566 31.086-1.4688 7.8945-8.3867 13.324-16.285 13.324-8.8828 0-16.285-7.4023-16.285-16.285 0-9.375 7.4023-16.777 16.285-16.777 4.9336 0 9.8711 2.4688 13.324 6.9102 10.363-4.4414 18.754-12.828 23.684-23.688 6.4141-16.285 2.9609-35.035-9.375-47.371-12.336-12.336-31.086-16.285-47.371-9.375-16.285 6.9102-26.645 22.699-26.645 39.969h-13.324c0-22.699 13.816-43.422 35.035-52.305 4.9336-1.9805 10.855-3.4531 16.285-3.9492h5.9219z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.76 34.703v459.2h228.13c-2.5547-3.5938-4.957-7.3008-7.0664-11.199h-209.87v-436.8h324.8v278.85c3.8047 0.69531 7.543 1.5625 11.199 2.6484v-292.7z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.36 127.48c-39.262 0-71.203 31.941-71.203 71.203 0 39.262 31.941 71.203 71.203 71.203s71.215-31.941 71.215-71.203c0-39.262-31.953-71.203-71.215-71.203zm0 35.984c10.805 0 19.676 8.8594 19.676 19.668 0 10.805-8.8711 19.664-19.676 19.664s-19.664-8.8594-19.664-19.664c0-10.805 8.8594-19.668 19.664-19.668zm0 11.18c-4.7656 0-8.4883 3.7188-8.4883 8.4883 0 4.7656 3.7188 8.4883 8.4883 8.4883s8.4883-3.7188 8.4883-8.4883c0-4.7656-3.7188-8.4883-8.4883-8.4883zm-33.742 24.305h11.18v23.777h45.141v-23.777h11.18v34.969h-67.496v-34.969z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.67 302.45v11.188h177.39v-11.188z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.67 346.19v11.188h152.5c3.7695-4.0273 7.8125-7.7734 12.152-11.188z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.67 389.93v11.188h127.53c1.1094-3.8164 2.3789-7.5586 3.8828-11.188z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 644,
    xlinkHref: "#w"
  }), /*#__PURE__*/React.createElement("use", {
    x: 90.550781,
    y: 644,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 104.359375,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 123.347656,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 142.242188,
    y: 644,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 155.628906,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 174.617188,
    y: 644,
    xlinkHref: "#l"
  }), /*#__PURE__*/React.createElement("use", {
    x: 204.410156,
    y: 644,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    x: 224.453125,
    y: 644,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("use", {
    x: 252.453125,
    y: 644,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 282.71875,
    y: 644,
    xlinkHref: "#v"
  }), /*#__PURE__*/React.createElement("use", {
    x: 301.820312,
    y: 644,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 321.753906,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 340.648438,
    y: 644,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 360.582031,
    y: 644,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 380.625,
    y: 644,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    x: 409.265625,
    y: 644,
    xlinkHref: "#u"
  }), /*#__PURE__*/React.createElement("use", {
    x: 430.9375,
    y: 644,
    xlinkHref: "#t"
  }), /*#__PURE__*/React.createElement("use", {
    x: 440.535156,
    y: 644,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("use", {
    x: 460.578125,
    y: 644,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 480.511719,
    y: 644,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 499.5,
    y: 644,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("use", {
    x: 516.167969,
    y: 644,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 70,
    y: 672,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("use", {
    x: 82.183594,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 95.992188,
    y: 672,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 115.226562,
    y: 672,
    xlinkHref: "#q"
  }), /*#__PURE__*/React.createElement("use", {
    x: 154.152344,
    y: 672,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    x: 167.535156,
    y: 672,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    x: 187.46875,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 216.207031,
    y: 672,
    xlinkHref: "#p"
  }), /*#__PURE__*/React.createElement("use", {
    x: 239.640625,
    y: 672,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 258.878906,
    y: 672,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("use", {
    x: 278.8125,
    y: 672,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("use", {
    x: 308.492188,
    y: 672,
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("use", {
    x: 329.015625,
    y: 672,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("use", {
    x: 342.820312,
    y: 672,
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    x: 362.058594,
    y: 672,
    xlinkHref: "#n"
  }), /*#__PURE__*/React.createElement("use", {
    x: 371.65625,
    y: 672,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    x: 390.648438,
    y: 672,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("use", {
    x: 407.242188,
    y: 672,
    xlinkHref: "#b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDetails);
export default __webpack_public_path__ + "static/media/editDetails.65974cd350f0bba9d73847915c7be0ff.svg";
export { ForwardRef as ReactComponent };